'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-369/overrides/components/contact/contact-form.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/5ad0c6b46d1a").then(m => ({ default: m.ContactForm })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-369/overrides/components/contact/contact-form.tsx").ContactForm>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-369/overrides/components/contact/contact-form.tsx").ContactForm;
export { Island0 as ContactForm };
